export default "__VITE_ASSET__BM$sHD5u__"